/* Sitescript van het thema.

   1. Ankerlinks (href="#...") scrollen zelf naar hun doel. Het oude thema
      verlegt de scrollhouder (overflow op body en #PageContainer), waardoor de
      standaardsprong van de browser niets doet. Zo werkt "Dit zijn wij" op de
      homepage weer.

   2. Winkelwagenlade. Eén plek voor alles wat wijn toevoegt:
   - de knop "+ In winkelwagen" op elke wijnkaart (één fles)
   - het bestelformulier op de productpagina, met de aantalkiezer
   - het wagentje in de kop
   De inhoud komt uit sections/wm-lade.liquid via de Section Rendering API,
   zodat prijzen en regels altijd door Shopify zelf worden berekend. Zonder
   JavaScript werkt alles nog: de links en formulieren gaan dan naar /cart. */
(function () {
  document.addEventListener("click", function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || e.defaultPrevented) return;
    var id = decodeURIComponent(a.getAttribute("href").slice(1));
    var doel = id && document.getElementById(id);
    if (!doel) return;
    e.preventDefault();
    var snel = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    doel.scrollIntoView({ behavior: snel ? "auto" : "smooth", block: "start" });
    if (history.pushState) history.pushState(null, "", "#" + id);
    if (!doel.hasAttribute("tabindex")) doel.setAttribute("tabindex", "-1");
    doel.focus({ preventScroll: true });
  });
})();

(function () {
  if (window.wmLade) return;
  var lade = document.getElementById("wm-lade");
  if (!lade) return;
  var paneel = lade.querySelector(".wm-lade-paneel");
  var inhoud = document.getElementById("wm-lade-inhoud");
  var statusVak = document.getElementById("wm-lade-status");
  var laatsteOpener = null;
  var statusTimer = null;
  // `laatsteGoed` is de laatste inhoud die Shopify zelf gaf; `fout` staat aan
  // zolang een verzoek is mislukt en de lade dus niet zeker klopt.
  var laatsteGoed = null, fout = false;
  var opCartPagina = /^\/cart\/?$/.test(location.pathname);

  function json(r) { return r.ok ? r.json() : r.json().then(function (e) { return Promise.reject(e); }, function () { return Promise.reject({}); }); }

  function zetInhoud(html, focusNa) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var root = doc.getElementById("wm-lade-root");
    if (!root) return;
    laatsteGoed = html;
    fout = false;
    var hadFocus = inhoud.contains(document.activeElement);
    inhoud.innerHTML = "";
    inhoud.appendChild(document.importNode(root, true));
    zetTeller(Number(root.getAttribute("data-aantal")) || 0);
    // Focus terug op dezelfde knop; anders valt hij op <body>.
    if (focusNa && (hadFocus || document.activeElement === document.body)) {
      for (var i = 0; i < focusNa.length; i++) {
        var el = inhoud.querySelector(focusNa[i]);
        if (el && !el.disabled) { el.focus(); break; }
      }
    }
  }

  function zetTeller(flessen) {
    var knop = document.querySelector(".wm-cart-knop");
    if (!knop) return;
    var teller = document.getElementById("wm-teller");
    if (flessen > 0) {
      if (!teller) {
        teller = document.createElement("span");
        teller.className = "wm-cart-teller";
        teller.id = "wm-teller";
        knop.appendChild(teller);
      }
      teller.textContent = flessen;
      knop.setAttribute("aria-label", "Winkelwagen openen, " + flessen + " " + (flessen === 1 ? "fles" : "flessen"));
    } else {
      if (teller) teller.remove();
      knop.setAttribute("aria-label", "Winkelwagen openen, nog leeg");
    }
  }

  function toonStatus(tekst, knopTekst, actie) {
    clearTimeout(statusTimer);
    statusVak.innerHTML = "";
    var p = document.createElement("span");
    p.textContent = tekst;
    statusVak.appendChild(p);
    var b = null;
    if (knopTekst) {
      b = document.createElement("button");
      b.type = "button";
      b.textContent = knopTekst;
      b.addEventListener("click", function () { statusVak.hidden = true; actie(); });
      statusVak.appendChild(b);
    }
    statusVak.hidden = false;
    statusTimer = setTimeout(function () { statusVak.hidden = true; }, knopTekst ? 20000 : 7000);
    return b;
  }

  function bezig(aan) { inhoud.setAttribute("aria-busy", aan ? "true" : "false"); }

  // Geeft true of false terug; faalt nooit.
  function haal() {
    bezig(true);
    return fetch("/?sections=wm-lade", { credentials: "same-origin" })
      .then(json)
      .then(function (d) { zetInhoud(d["wm-lade"]); return true; })
      .catch(function () { return false; })
      .finally(function () { bezig(false); });
  }

  // Lukt ook ophalen niet, dan nooit een lege lade: een uitweg naar de winkelwagenpagina.
  function vulLeeg() {
    if (inhoud.querySelector("#wm-lade-root")) return;
    inhoud.innerHTML = '<div class="wm-lade-fout"><p>Je winkelwagen laden lukte even niet.</p><a class="wm-lade-naar-wagen" href="/cart">Bekijk winkelwagen</a></div>';
  }

  function haalOfMeld() {
    return haal().then(function (ok) {
      if (!ok) { vulLeeg(); toonStatus("Je winkelwagen laden lukte even niet.", "Opnieuw proberen", haalOfMeld); }
      return ok;
    });
  }

  // Na een mislukt verzoek de laatste stand van Shopify terugzetten: de lade
  // mag nooit een aantal tonen dat niet in de winkelwagen staat.
  function herstel() {
    if (laatsteGoed) zetInhoud(laatsteGoed);
    fout = true;
  }

  function focusbaar() {
    return [].slice.call(paneel.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function open(opener) {
    if (!lade.hidden) return Promise.resolve();
    laatsteOpener = opener || document.activeElement;
    lade.hidden = false;
    document.documentElement.classList.add("wm-lade-open");
    // Eerst de begintoestand laten berekenen (reflow), dan pas de klasse die
    // de overgang start. Geen requestAnimationFrame: dat pauzeert in een
    // tabblad op de achtergrond, en dan zou de lade dicht blijven.
    void paneel.offsetWidth;
    lade.classList.add("is-open");
    var sluitKnop = paneel.querySelector(".wm-lade-sluit");
    setTimeout(function () { (sluitKnop || paneel).focus(); }, 60);
    return Promise.resolve();
  }

  function sluit() {
    if (lade.hidden) return;
    lade.classList.remove("is-open");
    document.documentElement.classList.remove("wm-lade-open");
    var klaar = function () { lade.hidden = true; };
    var snel = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (snel) klaar(); else setTimeout(klaar, 300);
    if (laatsteOpener && document.contains(laatsteOpener)) laatsteOpener.focus();
  }

  // Wijzigingen één voor één naar Shopify, zodat snelle klikken elkaar niet inhalen.
  // `lopend` telt verzoeken die nog onderweg zijn; afrekenen wacht daarop.
  var rij = Promise.resolve(), lopend = 0;
  function inRij(taak) {
    lopend++;
    var p = rij.then(taak);
    // `fout` hier zetten, vóór iemand die op `rij` wacht (afrekenen) verder gaat.
    rij = p.catch(function () { fout = true; });
    rij.then(function () { lopend--; });
    return p;
  }

  function voegToe(items, opener, naam, focusNa, bijSucces) {
    bezig(true);
    return inRij(function () {
      return fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items, sections: "wm-lade" })
      }).then(json);
    })
      .then(function (d) {
        zetInhoud(d.sections && d.sections["wm-lade"], focusNa);
        open(opener);
        if (naam) toonStatus("Toegevoegd: " + naam + ".");
        if (bijSucces) bijSucces();
      })
      .catch(function (e) {
        open(opener);
        // Shopify weigert met reden (bijvoorbeeld niet genoeg voorraad): die reden tonen.
        if (e && e.description) toonStatus(e.description);
        else {
          herstel();
          toonStatus("Toevoegen lukte even niet. Probeer het zo opnieuw.", "Opnieuw proberen", function () {
            voegToe(items, opener, naam, focusNa, bijSucces);
          });
        }
        return haal().then(function (ok) { if (!ok) vulLeeg(); });
      })
      .finally(function () { bezig(false); });
  }

  // Regels wijzigen via hun vaste sleutel, niet via het regelnummer: dat
  // schuift op zodra er een regel verdwijnt.
  function wijzig(sleutel, aantal, focusNa, actueel) {
    bezig(true);
    return inRij(function () {
      return fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: sleutel, quantity: aantal, sections: "wm-lade" })
      }).then(json);
    })
      .then(function (d) {
        // Is er intussen opnieuw getikt, dan volgt er nog een verzoek; dit
        // antwoord is dan al verouderd en zou het aantal terugzetten.
        if (actueel && !actueel()) return;
        zetInhoud(d.sections && d.sections["wm-lade"], focusNa);
      })
      .finally(function () { bezig(false); });
  }

  // Het nieuwe aantal meteen tonen; de prijs wordt even grijs tot Shopify rekent.
  var wachtend = {}, versie = {}, stuurNu = {};
  function zetAantalRegel(regel, n) {
    regel.dataset.aantal = n;
    regel.setAttribute("aria-busy", "true");
    var w = regel.querySelector(".wm-qty-waarde");
    if (w) w.textContent = n + (n === 1 ? " fles" : " flessen");
    var min = regel.querySelector('[data-richting="min"]');
    if (min) min.disabled = n <= 1;
    // De teller in de kop loopt direct mee, niet pas als Shopify antwoordt.
    var som = 0;
    [].forEach.call(inhoud.querySelectorAll(".wm-lade-regel"), function (r) { som += Number(r.dataset.aantal) || 0; });
    zetTeller(som);
  }

  // Knoppen in de lade zelf.
  lade.addEventListener("click", function (e) {
    if (e.target.closest("[data-lade-sluit]")) { sluit(); return; }
    var stap = e.target.closest(".wm-lade-stap");
    var weg = e.target.closest(".wm-lade-weg");
    if (!stap && !weg) return;
    var regel = e.target.closest(".wm-lade-regel");
    if (!regel) return;
    var sleutel = regel.dataset.sleutel, aantal = Number(regel.dataset.aantal);
    var variant = Number(regel.dataset.variant), naam = regel.dataset.naam;
    var hier = '.wm-lade-regel[data-sleutel="' + sleutel + '"] ';
    if (stap) {
      if (stap.disabled) return;
      var richting = stap.dataset.richting;
      var nieuw = richting === "plus" ? aantal + 1 : aantal - 1;
      if (nieuw < 1) return;
      zetAantalRegel(regel, nieuw);
      if (stap.disabled) regel.querySelector('[data-richting="plus"]').focus();
      // Een oude melding ("Toegevoegd: 3× …") klopt niet meer zodra je wijzigt.
      clearTimeout(statusTimer);
      statusVak.hidden = true;
      var mijn = versie[sleutel] = (versie[sleutel] || 0) + 1;
      // Pas na een korte pauze versturen, met het laatste aantal: drie snelle
      // tikken worden zo drie flessen erbij, niet één.
      clearTimeout(wachtend[sleutel]);
      var verstuur = stuurNu[sleutel] = function () {
        clearTimeout(wachtend[sleutel]);
        delete wachtend[sleutel];
        delete stuurNu[sleutel];
        return wijzig(sleutel, nieuw, [hier + '.wm-lade-stap[data-richting="' + richting + '"]', hier + '.wm-lade-stap[data-richting="plus"]'],
          function () { return versie[sleutel] === mijn; })
          .catch(function (e) {
            if (versie[sleutel] !== mijn) return; // een nieuwere tik is al onderweg
            herstel();
            // Weigert Shopify met een reden (bijvoorbeeld voorraad), dan die reden; opnieuw proberen helpt dan niet.
            if (e && e.description) toonStatus(e.description);
            else toonStatus("Het aantal wijzigen lukte even niet; je winkelwagen staat weer zoals hij was.", "Opnieuw proberen", verstuur);
            haal();
          });
      };
      wachtend[sleutel] = setTimeout(verstuur, 350);
      return;
    }
    clearTimeout(wachtend[sleutel]);
    delete wachtend[sleutel];
    delete stuurNu[sleutel];
    wijzig(sleutel, 0).then(function () {
      var terug = toonStatus(naam + " is uit je winkelwagen gehaald.", "Ongedaan maken", function () {
        voegToe([{ id: variant, quantity: aantal }], null, null, ['.wm-lade-regel[data-variant="' + variant + '"] .wm-lade-titel'], function () {
          toonStatus(naam + " staat weer in je winkelwagen.");
        });
      });
      if (terug) terug.focus();
    }).catch(function () {
      herstel();
      toonStatus("Verwijderen lukte even niet.", "Opnieuw proberen", function () {
        var w = inhoud.querySelector(hier + ".wm-lade-weg");
        if (w) w.click();
      });
    });
  });

  // Afrekenen wacht tot alle wijzigingen binnen zijn. Anders gaat een tik die
  // nog in de wachttijd zat verloren, of rekent de checkout met een ander
  // aantal dan de lade toont.
  lade.addEventListener("submit", function (e) {
    var knop = e.target.querySelector('[name="checkout"]');
    if (!knop) return;
    var openstaand = Object.keys(stuurNu);
    if (!openstaand.length && lopend === 0 && !fout) return;
    e.preventDefault();
    var tekst = knop.textContent;
    knop.disabled = true;
    knop.textContent = "Even bijwerken…";
    openstaand.forEach(function (k) { stuurNu[k](); });
    rij.then(function () {
      if (!fout) { location.href = "/checkout"; return; }
      // Er ging iets mis: eerst de echte stand van Shopify tonen, dan pas afrekenen.
      haal().then(function (ok) {
        if (ok) { toonStatus("Je winkelwagen is bijgewerkt. Kijk de aantallen na en reken dan af."); return; }
        knop.disabled = false;
        knop.textContent = tekst;
        toonStatus("Afrekenen lukt even niet. Probeer het zo opnieuw.", "Opnieuw proberen", function () { knop.form.requestSubmit(); });
      });
    });
  });

  // Escape sluit, Tab blijft binnen de lade.
  document.addEventListener("keydown", function (e) {
    if (lade.hidden) return;
    if (e.key === "Escape") { e.preventDefault(); sluit(); return; }
    if (e.key !== "Tab") return;
    var els = focusbaar();
    if (!els.length) return;
    var eerste = els[0], laatste = els[els.length - 1];
    if (e.shiftKey && (document.activeElement === eerste || document.activeElement === paneel)) { e.preventDefault(); laatste.focus(); }
    else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
  });

  // Wagentje in de kop. Op de winkelwagenpagina zelf gewoon doorlinken.
  document.addEventListener("click", function (e) {
    var knop = e.target.closest(".wm-cart-knop");
    if (!knop || opCartPagina || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open(knop);
    haalOfMeld();
  });

  // "+ In winkelwagen" op elke wijnkaart: één fles.
  document.addEventListener("click", function (e) {
    var knop = e.target.closest(".wm-quick-add[data-variant]");
    if (!knop || knop.disabled) return;
    e.preventDefault();
    knop.disabled = true;
    // Zichtbaar bezig: Shopify antwoordt meestal snel, maar niet altijd.
    var tekst = knop.innerHTML;
    knop.textContent = "Toevoegen…";
    knop.setAttribute("aria-busy", "true");
    var kaart = knop.closest(".wm-kaart");
    var naam = kaart ? kaart.dataset.titel : null;
    voegToe([{ id: Number(knop.dataset.variant), quantity: 1 }], knop, naam)
      .finally(function () { knop.disabled = false; knop.innerHTML = tekst; knop.removeAttribute("aria-busy"); });
  });

  // Bestelformulier op de productpagina. In de capture-fase, zodat het script
  // van het oude thema dit formulier niet ook nog eens verstuurt.
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.wm-product-buy form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopPropagation();
    var knop = form.querySelector('[type="submit"]');
    var knopTekst = knop ? knop.innerHTML : "";
    if (knop) { knop.disabled = true; knop.textContent = "Toevoegen…"; knop.setAttribute("aria-busy", "true"); }
    var fd = new FormData(form);
    var titel = document.querySelector(".wm-pdp-info h1");
    var aantal = Math.max(1, Math.min(99, parseInt(fd.get("quantity"), 10) || 1));
    var naam = titel ? (aantal > 1 ? aantal + "× " : "") + titel.textContent.trim() : null;
    var veld = form.querySelector(".wm-product-aantal input");
    // Na toevoegen terug naar 1 fles; anders voegt een tweede klik weer hetzelfde aantal toe.
    voegToe([{ id: Number(fd.get("id")), quantity: aantal }], knop, naam, null, function () {
      if (veld) { veld.value = 1; veld.dispatchEvent(new Event("input", { bubbles: true })); }
    })
      .finally(function () { if (knop) { knop.disabled = false; knop.innerHTML = knopTekst; knop.removeAttribute("aria-busy"); } });
  }, true);

  window.wmLade = { open: function () { open(); return haalOfMeld(); }, sluit: sluit, teller: zetTeller };
})();

/* 3. Aantalkiezer op de productpagina: min/plus, en de prijs op de knop loopt
      mee (prijs per fles × aantal, in de notatie van de winkel: €1.234,50). */
(function () {
  function euro(centen) {
    var s = (centen / 100).toFixed(2).split(".");
    return "€" + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + s[1];
  }
  function bij(veld) {
    var n = Math.max(1, Math.min(99, parseInt(veld.value, 10) || 1));
    var kiezer = veld.closest(".wm-product-aantal");
    kiezer.querySelector('[data-aantal="min"]').disabled = n <= 1;
    kiezer.querySelector('[data-aantal="plus"]').disabled = n >= 99;
    var totaal = veld.form && veld.form.querySelector("[data-totaal]");
    var bedrag = euro(Number(veld.dataset.prijs) * n);
    if (totaal) totaal.textContent = bedrag;
    var status = document.getElementById("wm-aantal-status");
    if (status) status.textContent = n + (n === 1 ? " fles" : " flessen") + ", " + bedrag;
    return n;
  }
  document.addEventListener("click", function (e) {
    var k = e.target.closest(".wm-product-aantal [data-aantal]");
    if (!k || k.disabled) return;
    var veld = k.closest(".wm-product-aantal").querySelector("input");
    var n = (parseInt(veld.value, 10) || 1) + (k.dataset.aantal === "plus" ? 1 : -1);
    veld.value = Math.max(1, Math.min(99, n));
    bij(veld);
  });
  document.addEventListener("input", function (e) {
    if (e.target.matches && e.target.matches(".wm-product-aantal input")) bij(e.target);
  });
  // Stil bijstellen verwart: zeg het als het getypte aantal buiten 1–99 viel.
  var hintTimer = null;
  function corrigeer(e) {
    if (!e.target.matches || !e.target.matches(".wm-product-aantal input")) return;
    var ruw = parseInt(e.target.value, 10);
    var n = e.target.value = bij(e.target);
    var hint = document.getElementById("wm-aantal-hint");
    if (!hint) return;
    clearTimeout(hintTimer);
    if (ruw === n) { if (e.type === "change") hint.hidden = true; return; }
    hint.textContent = n === 99 ? "Maximaal 99 flessen per keer. Meer nodig? Mail ons gerust." : "Minimaal 1 fles; het aantal staat weer op 1.";
    hint.hidden = false;
    var status = document.getElementById("wm-aantal-status");
    if (status) status.textContent = hint.textContent;
    hintTimer = setTimeout(function () { hint.hidden = true; }, 6000);
  }
  document.addEventListener("change", corrigeer);
  document.addEventListener("focusout", corrigeer);
})();

/* 4. Gerelateerde wijnen onder de productpagina, via Shopify's aanbevelingen
      (sections/wm-gerelateerd.liquid). Geen aanbevelingen: niets tonen. */
(function () {
  var doel = document.getElementById("wm-gerelateerd");
  if (!doel || !doel.dataset.url) return;
  fetch(doel.dataset.url, { credentials: "same-origin" })
    .then(function (r) { return r.ok ? r.text() : ""; })
    .then(function (html) {
      var inhoud = new DOMParser().parseFromString(html, "text/html").getElementById("wm-gerelateerd-inhoud");
      if (inhoud) doel.appendChild(document.importNode(inhoud, true));
    })
    .catch(function () {});
})();
